import { mutatorAction } from 'satcheljs';
import getCalendarConfiguration from '../utils/getCalendarConfiguration';
var assign = require('object-assign');
export default mutatorAction('updateCalendarMailboxConfiguration', function updateCalendarMailboxConfiguration(calendarConfiguration) {
    assign(getCalendarConfiguration(), calendarConfiguration);
});
//# sourceMappingURL=updateCalendarMailboxConfiguration.js.map